import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import View from '../../../modal/Users_Management/Manage_Users/UserView';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import staff1 from '../../../../images/staff/member_2.png';
import staff2 from '../../../../images/staff/member_1.png';
import axios from 'axios';

const Manage_Users = () => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    
    // page table data fetch
    const fetchData = () => {
        const params = {      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,  // add search string
            branch_id: branch_id
        };
        axios.get(`${baseURL}/usermanagement`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);

            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };
    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);

    const tableRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [open, setOpen] = useState(false);

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };


    const [selectedRow, setSelectedRow] = useState({});
    const CreateModalOpen = (selectedRow) => {
        setSelectedRow(selectedRow);
        setShowModal("View");
        setOpen(true);
    };


    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Users</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Users Management</li>
                    </ol>
                </div>
                <div className='d-flex alignjitems-center mb-2'>
                    {open && showModal === "View" && (
                        <View show={open} onClose={() => setOpen(false)} data={selectedRow} />
                    )}
                </div>
            </div>
            <div className="table-container">

                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>


                <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-100px'>User</th>
                            <th className='min-w-100px'>Branch/Date</th>
                            <th className='min-w-80px'>Role/Department</th>
                            <th className='min-w-80px'>Created By</th>
                            <th className='min-w-80px'>Status</th>
                            <th className='min-w-80px'>Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {datas.length === 0 && hasFetched ? (
                            <tr>
                                <td colSpan="6" className="text-center text-muted py-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            <>
                                {datas.map((data, index) => (
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={data.staff_image ? data.staff_image : staff2} className='border rounded px-1 py-0'>
                                                        <img src={data.staff_image ? data.staff_image : staff2} alt={data.staff_name} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>{data.staff_name}</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>{data.branch}</label>
                                            <div className='d-block'>
                                                <label className='text-dark font-w500 fs-7'>{data.date}</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>{data.role}</label>
                                            <div className='d-block'>
                                                <label className='text-white bg-secondary py-1 px-2 rounded font-w500 fs-7'>{data.department}</label>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={data.created_by_image ? data.created_by_image : staff2} className='border rounded px-1 py-0'>
                                                        <img src={data.created_by_image ? data.created_by_image : staff2} alt={data.created_by_name} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>{data.created_by_name}</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-white bg-info py1 px-2 rounded font-w500 fs-7'>{data.status}</label>
                                        </td>
                                        <td>
                                            <span class="text-end">
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => CreateModalOpen(data)}>
                                                        <span><i class="fa-solid fa-eye fs-6 mt-1"></i></span>
                                                    </Button>
                                                </OverlayTrigger>
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </>
                        )}
                    </tbody>
                </table>

                <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {datas.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                            </span>
                        ):(
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    {/* <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav> */}
                    
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            {/* Previous Button */}
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                Previous
                            </button>
                            </li>

                            {/* First Page */}
                            <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                1
                            </button>
                            </li>

                            {/* Left Ellipsis */}
                            {page > 4 && (
                            <li className="page-item disabled">
                                <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                            </li>
                            )}

                            {/* Pages Around Current */}
                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                            .map(p => (
                                <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                    {p}
                                </button>
                                </li>
                            ))}

                            {/* Right Ellipsis */}
                            {page < totalPages - 3 && (
                            <li className="page-item disabled">
                                <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                            </li>
                            )}

                            {/* Last Page */}
                            {totalPages > 1 && (
                            <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                {totalPages}
                                </button>
                            </li>
                            )}

                            {/* Next Button */}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                Next
                            </button>
                            </li>
                        </ul>
                    </nav>

                </div>
            </div>

        </>
    )
}
export default Manage_Users;